import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService, GET, Adapter, POST, Body, Query } from '@royalty/httpclient';

@Injectable()
export class AccountService extends HttpService {

	/**
	 * User API
	 */
	@GET('account/users')
	@Adapter(null, { isAdmin: true })
	getUsers(): Observable<any> {
		return null;
	}

	@GET('account/user')
	@Adapter(null, { isAdmin: true })
	getUser(@Query('id') id: string): Observable<any> {
		return null;
	}

	@POST('account/create')
	@Adapter(null, { isAdmin: true })
	createUser(@Body data: string): Observable<any> {
		return null;
	}

	@POST('account/update')
	@Adapter(null, { isAdmin: true })
	updateUser(@Body data: string): Observable<any> {
		return null;
	}

	@POST('account/delete')
	@Adapter(null, { isAdmin: true })
	deleteUser(@Body data: string): Observable<any> {
		return null;
	}

	@POST('account/lock')
	@Adapter(null, { isAdmin: true })
	lockUser(@Body data: string): Observable<any> {
		return null;
	}

	@POST('account/unlock')
	@Adapter(null, { isAdmin: true })
	unLockUser(@Body data: string): Observable<any> {
		return null;
	}

	@POST('account/changePassword')
	@Adapter(null, { isAdmin: true })
	changePassword(@Body data: string): Observable<any> {
		return null;
	}

	/**
	 * User Role
	 */
	@GET('role/list')
	@Adapter(null, { isAdmin: true })
	getRoles(): Observable<any> {
		return null;
	}

	@GET('role/getbyid')
	@Adapter(null, { isAdmin: true })
	getRole(@Query('id') id: string): Observable<any> {
		return null;
	}

	@POST('role/create')
	@Adapter(null, { isAdmin: true })
	createRole(@Body data: string): Observable<any> {
		return null;
	}

	@POST('role/update')
	@Adapter(null, { isAdmin: true })
	updateRole(@Body data: string): Observable<any> {
		return null;
	}

	@POST('role/delete')
	@Adapter(null, { isAdmin: true })
	deleteRole(@Body data: string): Observable<any> {
		return null;
	}

	@GET('permission/list')
	@Adapter(null, { isAdmin: true })
	getPermissions(): Observable<any> {
		return null;
	}
}
